// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attachments-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.attachments-count {
  background-color: var(--background-light);
  color: var(--text-secondary);
  font-size: 10px;
  padding: 4px 8px;
  border-radius: 12px;
  font-weight: 500;
}

.select-all-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  border: 2px dashed var(--border-light);
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-bottom: 8px;
}

.select-all-wrapper:hover {
  background-color: var(--background-light);
}

.select-all-wrapper input[type="checkbox"] {
  width: 16px;
  height: 16px;
  border: 1px solid var(--border-light);
  border-radius: 4px;
  cursor: pointer;
  accent-color: var(--primary);
}

.select-all-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  cursor: pointer;
  user-select: none;
}

.attachments-card {
  background-color: var(--surface-light);
  border: 1px solid var(--border-light);
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.attachment-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.attachment-item:hover {
  background-color: var(--background-light);
}

.attachment-item + .attachment-item {
  border-top: 1px solid var(--border-light);
}

.attachment-checkbox {
  width: 16px;
  height: 16px;
  border: 1px solid var(--border-light);
  border-radius: 4px;
  cursor: pointer;
  accent-color: var(--primary);
  flex-shrink: 0;
}

.attachment-icon {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.attachment-icon.icon-image {
  background-color: var(--icon-purple-bg);
  color: var(--icon-purple);
}

.attachment-icon.icon-spreadsheet {
  background-color: var(--icon-green-bg);
  color: var(--icon-green);
}

.attachment-icon.icon-pdf {
  background-color: var(--icon-red-bg);
  color: var(--icon-red);
}

.attachment-icon.icon-default {
  background-color: var(--icon-gray-bg);
  color: var(--icon-gray);
}

.attachment-icon .material-icons-round {
  font-size: 18px;
}

.attachment-info {
  flex: 1;
  min-width: 0;
}

.attachment-name {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.attachment-size {
  font-size: 10px;
  color: var(--text-muted);
  margin-top: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/AttachmentsList/AttachmentsList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB","sourcesContent":[".attachments-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.attachments-count {\n  background-color: var(--background-light);\n  color: var(--text-secondary);\n  font-size: 10px;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-weight: 500;\n}\n\n.select-all-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px;\n  border: 2px dashed var(--border-light);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  margin-bottom: 8px;\n}\n\n.select-all-wrapper:hover {\n  background-color: var(--background-light);\n}\n\n.select-all-wrapper input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  cursor: pointer;\n  accent-color: var(--primary);\n}\n\n.select-all-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  cursor: pointer;\n  user-select: none;\n}\n\n.attachments-card {\n  background-color: var(--surface-light);\n  border: 1px solid var(--border-light);\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n}\n\n.attachment-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.attachment-item:hover {\n  background-color: var(--background-light);\n}\n\n.attachment-item + .attachment-item {\n  border-top: 1px solid var(--border-light);\n}\n\n.attachment-checkbox {\n  width: 16px;\n  height: 16px;\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  cursor: pointer;\n  accent-color: var(--primary);\n  flex-shrink: 0;\n}\n\n.attachment-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.attachment-icon.icon-image {\n  background-color: var(--icon-purple-bg);\n  color: var(--icon-purple);\n}\n\n.attachment-icon.icon-spreadsheet {\n  background-color: var(--icon-green-bg);\n  color: var(--icon-green);\n}\n\n.attachment-icon.icon-pdf {\n  background-color: var(--icon-red-bg);\n  color: var(--icon-red);\n}\n\n.attachment-icon.icon-default {\n  background-color: var(--icon-gray-bg);\n  color: var(--icon-gray);\n}\n\n.attachment-icon .material-icons-round {\n  font-size: 18px;\n}\n\n.attachment-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.attachment-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.attachment-size {\n  font-size: 10px;\n  color: var(--text-muted);\n  margin-top: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
